import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const FeedbackApp = lazyRetry(() => import('./FeedbackApp'));

const FeedbackAppRoute: FuseRouteItemType = {
    path: 'admin/feedback',
    element: <FeedbackApp />
};

export default FeedbackAppRoute;
